import { fetchGet, fetchPost, fetchPatch } from "@/lib/services";

export async function getBranchByCode(branchCode: string) {
  return await fetchGet(`/branches/?Branch_Code=${branchCode}`);
}

export async function getBranchEmployees(branchCode: string, page?: number, search?: string, status?: string) {
  const params = new URLSearchParams();
  params.append('Branch_Code', branchCode);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  return await fetchGet(`/employees/?${params.toString()}`);
}

export async function createBranchEmployee(data: any) {
  return await fetchPost('/employees/', data);
}

export async function updateBranchEmployee(id: number, data: any) {
  return await fetchPatch(`/employees/?Id=${id}`, data);
}

export async function getVerificationByBranch(branchCode: string, status?: any, page?: number) {
  const params = new URLSearchParams();
  params.append('Branch_Code', branchCode);
  if (status !== undefined) params.append('Status', String(status));
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/verfication/?${params.toString()}`);
}

export async function getMasterPricesByStateCity(stateCode: string, cityCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('State_Code', stateCode);
  params.append('City_Code', cityCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/masterprices/?${params.toString()}`);
}

export async function getMasterPricesHistoryByStateCity(stateCode: string, cityCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('State_Code', stateCode);
  params.append('City_Code', cityCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/masterpriceshistory/?${params.toString()}`);
}

export async function getSubscriptionsByStateCity(stateCode: string, cityCode?: string,plan?: string, page?: number,  search?: string,
) {
  const params = new URLSearchParams();
  params.append('State_Code', stateCode);
  if (cityCode) {
    params.append("City_Code", cityCode);
  }
  if (plan) params.append('Plan', plan);
  if (page && page > 1) params.append('page', String(page));
    if (search) params.append('Search', search.trim());
  return await fetchGet(`/plans/?${params.toString()}`);
}

export async function getSubscriptionsHistoryByStateCity(stateCode: string, cityCode: string, page?: number) {
  const params = new URLSearchParams();
  params.append('State_Code', stateCode);
  params.append('City_Code', cityCode);
  if (page && page > 1) params.append('page', String(page));
  return await fetchGet(`/plans-history/?${params.toString()}`);
}
